// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallbackPopup_date__i7q11 {
  font-weight: bold;
  padding: 15px;
  background-color: var(--color-theme-red);
}

.CallbackPopup_name__V-tEO {
  font-weight: bold;
  padding: 15px 15px;
}

.CallbackPopup_role__-hGHJ {
  font-size: 14px;
  padding: 5px 15px;
}

.CallbackPopup_email__R2ID7 {
  font-size: 14px;
  padding: 5px 15px;
}

.CallbackPopup_phone__yBNI0 {
  font-weight: bold;
  padding: 15px 15px;
}

.CallbackPopup_note__amBIU {
  border: 1px solid var(--color-theme-gray);
  padding: 15px;
  background-color: var(--color-theme-silver);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/CallbackPopup/CallbackPopup.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,2CAA2C;AAC7C","sourcesContent":[".date {\n  font-weight: bold;\n  padding: 15px;\n  background-color: var(--color-theme-red);\n}\n\n.name {\n  font-weight: bold;\n  padding: 15px 15px;\n}\n\n.role {\n  font-size: 14px;\n  padding: 5px 15px;\n}\n\n.email {\n  font-size: 14px;\n  padding: 5px 15px;\n}\n\n.phone {\n  font-weight: bold;\n  padding: 15px 15px;\n}\n\n.note {\n  border: 1px solid var(--color-theme-gray);\n  padding: 15px;\n  background-color: var(--color-theme-silver);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"date": `CallbackPopup_date__i7q11`,
	"name": `CallbackPopup_name__V-tEO`,
	"role": `CallbackPopup_role__-hGHJ`,
	"email": `CallbackPopup_email__R2ID7`,
	"phone": `CallbackPopup_phone__yBNI0`,
	"note": `CallbackPopup_note__amBIU`
};
export default ___CSS_LOADER_EXPORT___;
